import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import checkBlack from '../../../../../assets/images/icons/checkBlack.svg';
import eye from '../../../../../assets/images/icons/eye.svg';
import useThemeContext from '../../../../../contexts/theme';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
// import dateJsToReadableDate from '../../../../../utils/dateJsToReadableDate';
import floatToCurrency from '../../../../../utils/floatToCurrency';
import hideCpf from '../../../../../utils/hideCpf';
import { DadosConsulum } from '../../types';
import { StyledTr, TableContainer } from './styles';

interface ITableView {
  filteredConsults: DadosConsulum[];
  isSelectingConsults: boolean;
  selectedConsults: number[];
  handleConsultSelection: (cst: number) => void;
  selectedType: 'base' | 'preAdm';
}

export default function TableView({
  filteredConsults,
  isSelectingConsults,
  selectedConsults,
  handleConsultSelection,
  selectedType,
}: ITableView) {
  const smallTagRenderByStatusRot: { [key: string]: JSX.Element } = {
    Implantado: <small className='green'>Implantado</small>,
    Otimizado: <small className='green'>Otimizado</small>,
    'Não Otimizado': <small className='orange'>Não Otimizado</small>,
    'Acima do Teto': <small className='orange'>Acima do Teto</small>,
    'Acima do Valor': <small className='orange'>Acima do Valor</small>,
    'Sem Resultado': <small className='red'>Sem Resultado</small>,
    'Fora de Abrangência': <small className='red'>Fora de Abrangência</small>,
    'Caminhada a pé': <small>Caminhada a pé</small>,
    'Em processamento': <small>Em processamento</small>,
    'Sem Status': <small className='gray'>Sem Status</small>,
  };

  const smallTagRenderByStatusConsult: { [key: string]: JSX.Element } = {
    Roteirizado: <small>Roteirizado</small>,
    Implantado: <small className='green'>Implantado</small>,
  };

  const { companyCode } = useGetGeneralAppData();

  const { selectedTheme } = useThemeContext();

  return (
    <TableContainer>
      <Table responsive variant={selectedTheme === 'dark' ? 'dark' : ''} hover striped>
        <thead>
          <tr>
            <th>Consulta</th>
            <th>CPF</th>
            <th>Matrícula</th>
            <th>Nome</th>
            <th>Status Roteirização</th>
            {selectedType === 'base' &&
              <>
                <th>Valor Antes</th>
                <th>Valor Depois</th>
                <th>Economia</th>
              </>
            }
            {/* <th>Data Geração</th>
            <th>Última Roteirização</th>
            <th>Tipo</th> */}
            <th>Status Consulta</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {filteredConsults.map((cst) => (
            <StyledTr key={`${cst.codConsulta}|${cst.dataRot}`} isSelectingFiles={isSelectingConsults} selected={selectedConsults.includes(cst.codConsulta)}>
              <td>
                {cst.codConsulta}
              </td>
              <td>
                {hideCpf(cst.cpf) || 'Não informado'}
              </td>
              <td>
                {cst.matricula || 'Não informada'}
              </td>
              <td>
                {cst.nome}
              </td>
              <td>
                {smallTagRenderByStatusRot[cst.statusRot]}
              </td>
              {/* <td>
                {dateJsToReadableDate(cst.dataCad)}
              </td>
              <td>
                {dateJsToReadableDate(cst.dataRot)}
              </td> */}
              {selectedType === 'base' && (
                <>
                  <td>
                    {cst.valorAntes ? floatToCurrency(cst.valorAntes) : 'Não Informado'}
                  </td>
                  <td>
                    {cst.valorDepois ? floatToCurrency(cst.valorDepois) : 'Não Calculado'}
                  </td>
                  <td>
                    {cst.economia ? floatToCurrency(cst.economia) : 'Sem Economia'}
                  </td>
                </>
              )}
              {/* <td>
                {cst.tipoRoteirizacao || 'Sem Tipo'}
              </td> */}
              <td>
                {smallTagRenderByStatusConsult[cst.statusConsulta]}
              </td>
              {!isSelectingConsults && (
                <td>
                  <Link to={`/consults/result/${cst.codConsulta}?codEmpresa=${companyCode}&activeSidebar=SearchConsults&returnLink=${encodeURIComponent('/consults/search')}${cst.tipoRotas === 'MULTI ROTAS' ? '&mr' : ''}`}>
                    <img src={eye} alt="" title='Visualizar Resultado' />
                  </Link>
                </td>
              )}

              {isSelectingConsults && (
                <td>
                  <img src={checkBlack} onClick={() => handleConsultSelection(cst.codConsulta)} alt=""/>
                </td>
              )}
            </StyledTr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
}
